import styled, { CSSProperties } from 'styled-components';
import { theme } from '@goalsetter/ant-design-ui';
const { getDesignToken } = theme;

const globalToken = getDesignToken();

const StyledNoContentContainer = styled.div`
  align-items: center;
  justify-items: center;
  margin: ${({ theme }) => theme.marginLG}px;
`;

const imageStyles: CSSProperties = {
  width: '100%',
  aspectRatio: '2/1',
};

const whiteTextStyle: CSSProperties = {
  color: globalToken.colorTextLightSolid,
  textAlign: 'center',
};

export { StyledNoContentContainer, imageStyles, whiteTextStyle };
